// extracted by mini-css-extract-plugin
export default {"placeholder":"ShoppableOutfit___shoppableOutfitPlaceholder-module__placeholder___TKMAA"};